export default "__VITE_ASSET__CJAX2G$$__"